<template>
    <v-container
        fluid
        class="border border-gray-300 soli-round w-full h-auto flex flex-col py-1 relative"
    >
        <div
            v-if="
                formattingEnabled &&
                showFormatMenu &&
                (channel !== 'chat' || $vuetify.breakpoint.smAndUp)
            "
            class="flex gap-1"
        >
            <div v-for="(item, idx) in formatMenu" :key="idx">
                <v-btn
                    v-if="item.icon"
                    icon
                    small
                    :input-value="editor?.isActive(item.name)"
                    tabindex="1"
                    @click="item.apply()"
                    ><v-icon
                        :color="editor?.isActive(item.name) ? 'accent' : 'dark'"
                        >{{ item.icon }}</v-icon
                    ></v-btn
                >
                <v-divider v-if="!item.icon" vertical class="mx-2" />
            </div>
        </div>
        <editor-content
            :editor="editor"
            :class="{ 'mb-4': channel !== 'chat' }"
            class="editor"
        />

        <div class="flex justify-between overflow-hidden">
            <div
                v-if="channel"
                class="flex justify-start gap-2 shrink custom-animate animate__animated animate__fadeIn"
            >
                <div
                    v-if="channel == 'chat'"
                    :class="{ 'flex gap-2': !showFormatMenu }"
                >
                    <v-btn v-if="false" icon small color="dark"
                        ><v-icon>add_circle_outline</v-icon></v-btn
                    >
                    <v-btn
                        icon
                        small
                        color="dark"
                        tabindex="1"
                        @click="
                            [
                                (showFormatMenu = !showFormatMenu),
                                editor.commands.focus(),
                            ]
                        "
                    >
                        <v-icon>text_format</v-icon>
                    </v-btn>
                </div>
                <v-menu v-if="channel !== 'chat'" offset-x top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            elevation="0"
                            rounded
                            :disabled="!!thread?.id"
                            :color="channelColors(channel)"
                        >
                            <div class="font-weight-bold">
                                {{ channel }}
                            </div>
                            <v-divider
                                v-if="!thread?.id"
                                vertical
                                color="white"
                                class="ml-2"
                            />
                            <v-icon v-if="!thread?.id" right class="ml-1"
                                >keyboard_arrow_down</v-icon
                            >
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="changeChannel('sms')">
                            <v-list-item-title>SMS</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="changeChannel('email')">
                            <v-list-item-title>Email</v-list-item-title>
                        </v-list-item>
                        <v-list-item disabled @click="changeChannel('voice')">
                            <v-list-item-title>Voice</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu v-if="crmMode" offset-x top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            rounded
                            :loading="olliebotLoading"
                            :disabled="!message?.id"
                            elevation="0"
                            color="warning"
                            :class="{
                                'gradient-ai text-shadow-blue': !!message?.id,
                            }"
                        >
                            <v-icon small class="text-shadow-blue"
                                >auto_awesome</v-icon
                            >
                            <v-divider vertical color="white" class="ml-2" />
                            <v-icon right class="ml-1"
                                >keyboard_arrow_down</v-icon
                            >
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="askOlliebot('followUp')">
                            <v-list-item-title>Follow-up</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="askOlliebot('fileSearch')">
                            <v-list-item-title
                                >Suggest Response</v-list-item-title
                            >
                        </v-list-item>
                        <v-list-item @click="askOlliebot('findAvailability')">
                            <v-list-item-title
                                >Find Availability</v-list-item-title
                            >
                        </v-list-item>
                    </v-list>
                </v-menu>
                <div v-if="ollieResponse" class="flex gap-2 items-center ml-1">
                    <v-btn
                        x-small
                        icon
                        outlined
                        :loading="sentimentLoading == 'liked'"
                        color="success"
                        @click="reviewOlliebot('liked')"
                    >
                        <v-icon x-small>thumb_up</v-icon></v-btn
                    >
                    <v-btn
                        x-small
                        icon
                        outlined
                        color="error"
                        :loading="sentimentLoading == 'disliked'"
                        @click="reviewOlliebot('disliked')"
                    >
                        <v-icon x-small>thumb_down</v-icon></v-btn
                    >
                </div>
                <!--<v-btn
                    v-if="crmMode"
                    icon
                    outlined
                    small
                    :loading="olliebotLoading"
                    color="accent"
                    class="text-shadow-blue"
                    @click="askOlliebot()"
                    ><v-icon small>auto_awesome</v-icon></v-btn
                >-->
                <div
                    v-if="
                        channel == 'chat' &&
                        showFormatMenu &&
                        $vuetify.breakpoint.xs
                    "
                    class="flex px-2 gap-1"
                >
                    <div v-for="(item, idx) in formatMenu" :key="idx">
                        <v-btn
                            v-if="item.icon"
                            icon
                            small
                            @click="item.apply()"
                            :input-value="editor?.isActive(item.name)"
                            ><v-icon
                                :color="
                                    editor?.isActive(item.name)
                                        ? 'accent'
                                        : 'dark'
                                "
                                >{{ item.icon }}</v-icon
                            ></v-btn
                        >
                        <v-divider v-if="!item.icon" vertical class="mx-2" />
                    </div>
                </div>
            </div>
            <v-spacer />
            <div
                v-if="
                    characterLimit &&
                    editor &&
                    channel &&
                    (channel === 'chat'
                        ? !(showFormatMenu && $vuetify.breakpoint.xs)
                        : true)
                "
                class="caption whitespace-nowrap my-auto mr-4 animate__animated animate__fadeIn"
            >
                {{ editor.storage.characterCount.characters() }} /
                {{ characterLimit }}
            </div>
            <small v-if="showMacros" class="my-auto primary--text pt-0.5 pr-1"
                >+ Enter</small
            >
            <v-btn
                v-if="!hideSubmit"
                icon
                small
                :color="valid ? 'primary' : 'dark'"
                :disabled="!valid"
                :loading="processing"
                @modEnter="$log('enter')"
                @click="submit()"
                ><v-icon>{{ icon }}</v-icon>
            </v-btn>
        </div>
    </v-container>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import History from "@tiptap/extension-history";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Placeholder from "@tiptap/extension-placeholder";
import ListItem from "@tiptap/extension-list-item";
import BulletList from "@tiptap/extension-bullet-list";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import { Extension } from "@tiptap/core";
import Youtube from "@tiptap/extension-youtube";
import CharacterCount from "@tiptap/extension-character-count";
import { Slice, Fragment, Node } from "prosemirror-model";

export default {
    components: { EditorContent },
    inject: {
        showMacros: {
            default: false,
        },
    },
    props: {
        value: {
            type: String,
            default: "",
        },
        processing: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: false,
        },
        hideSubmit: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: true,
        },
        breakOnEnter: {
            type: Boolean,
            default: false,
        },
        characterLimit: {
            type: Number,
            default: null,
        },
        icon: {
            type: String,
            default: "send",
        },
        channel: {
            type: String,
            default: "",
        },
        editorType: {
            type: String,
            default: "html",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        thread: {
            type: Object,
            default: () => ({}),
            description:
                "This is the requested thread object passed down from top level component",
        },
        message: {
            type: Object,
            default: () => ({}),
            description:
                "This is a computed message from the immediate parent component, latest message in thread. Might not belong to the current thread",
        },
        client: {
            type: Object,
            default: () => ({}),
        },
        crmMode: {
            type: Boolean,
            default: false,
        },
        autoDraft: {
            type: Boolean,
            default: false,
            description:
                "This is used to determine if the olliebot should be used for auto drafting responses",
        },
    },

    data() {
        return {
            editor: null,
            olliebotLoading: false,
            sentimentLoading: null,
            ollieResponse: this.autoDraft,
            showFormatMenu:
                this.$vuetify.breakpoint.smAndUp || this.channel !== "chat",
            formatting: [],
            formatMenu: [
                {
                    name: "bold",
                    apply: () =>
                        this.editor?.chain().focus().toggleBold().run(),
                    icon: "format_bold",
                },
                {
                    name: "italic",
                    apply: () =>
                        this.editor?.chain().focus().toggleItalic().run(),
                    icon: "format_italic",
                },
                {
                    name: "underline",
                    apply: () =>
                        this.editor?.chain().focus().toggleUnderline().run(),
                    icon: "format_underline",
                },
                {
                    divider: true,
                },
                {
                    name: "bulletList",
                    apply: () =>
                        this.editor?.chain().focus().toggleBulletList().run(),
                    icon: "format_list_bulleted",
                },
            ],
        };
    },
    methods: {
        submit() {
            if (!this.valid) return;
            this.$emit("submit");
        },
        changeChannel(channel) {
            /*if (
                this.channel == "email" &&
                channel == "sms" &&
                this.overCharacterLimit
            ) {
                this.$emit("contentTrimmed");
            }*/

            this.$emit("changeChannel", channel);
        },
        channelColors(channel) {
            if (channel == "sms") return "secondary";
            if (channel == "mms") return "secondary";
            if (channel == "email") return "accent";
            if (channel == "voice") return "success";
            return "";
        },
        /**
         * Handle pasting text into the editor
         * This was initially to handle line breaks, but I'm no longer using hard breaks
         * Now this is to find plain text lists (-) and convert them to bullet lists for emails
         */
        clipboardTextParser(text, context, plain) {
            const blocks = text.replace().split(/(?:\r\n?|\n)/);
            const nodes = [];

            let listItems = []; // Temporary storage for list items
            blocks.forEach((line) => {
                if (line.trim().startsWith("-") && this.channel == "email") {
                    // If the line starts with "-", treat it as a list item
                    const listItemJson = {
                        type: "listItem",
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        type: "text",
                                        text: line.trim().substring(1).trim(),
                                    },
                                ],
                            },
                        ],
                    };
                    listItems.push(
                        Node.fromJSON(context.doc.type.schema, listItemJson)
                    );
                } else {
                    // If there are accumulated list items, wrap them in a bullet list
                    if (listItems.length > 0) {
                        const bulletListJson = {
                            type: "bulletList",
                            content: listItems.map((item) => item.toJSON()),
                        };
                        nodes.push(
                            Node.fromJSON(
                                context.doc.type.schema,
                                bulletListJson
                            )
                        );
                        listItems = []; // Clear the list items
                    }

                    // Add the current line as a paragraph
                    const paragraphJson = { type: "paragraph" };
                    if (line.length > 0) {
                        paragraphJson.content = [{ type: "text", text: line }];
                    }
                    nodes.push(
                        Node.fromJSON(context.doc.type.schema, paragraphJson)
                    );
                }
            });

            // If there are remaining list items, wrap them in a bullet list
            if (listItems.length > 0) {
                const bulletListJson = {
                    type: "bulletList",
                    content: listItems.map((item) => item.toJSON()),
                };
                nodes.push(
                    Node.fromJSON(context.doc.type.schema, bulletListJson)
                );
            }

            const fragment = Fragment.fromArray(nodes);
            return Slice.maxOpen(fragment);
        },
        askOlliebot(method) {
            this.olliebotLoading = true;
            this.ollieResponse = false;

            const params = new URLSearchParams({
                crmClientId: this.client.id,
                crmClientType: this.client.type,
                characterLimit: this.characterLimit,
                method: method,
            });

            const eventSource = new EventSource(
                `/api/openai/lead-help/${this.message.thread_id}?` +
                    params.toString()
            );

            eventSource.onmessage = (event) => {
                const data = JSON.parse(event.data);

                if (data.token) {
                    this.editor.commands.insertContent(data.token, false, {
                        preserveWhitespace:
                            this.channel == "sms" ? false : "full",
                    });
                }

                if (data.message) {
                    /*if (this.channel == "email") {
                        data.message = this.formatEmail(data.message);
                    }

                    if (this.channel == "sms") {
                        data.message = this.formatSMS(data.message);
                    }*/

                    data.message = this.formatLinks(data.message);
                    data.message = this.formatSpacing(data.message);

                    this.editor.commands.setContent(data.message, true, {
                        preserveWhitespace:
                            this.channel == "sms" ? false : "full",
                    });

                    this.olliebotLoading = false;
                    this.ollieResponse = true;
                    eventSource.close();
                }
            };

            eventSource.onerror = () => {
                console.error("Error with SSE connection.");
                this.olliebotLoading = false;
                this.$emit(
                    "error",
                    "Something went wrong, please try again or contact support"
                );
                eventSource.close();
            };
        },
        formatSpacing(content) {
            // Replace line breaks with <p> tags
            content = content
                .split(/\n+/) // Split by one or more line breaks
                .map((line) => {
                    // If the line starts with a dash, wrap it in <li> tags
                    if (line.trim().startsWith("-")) {
                        return `<li>${line.trim().substring(1).trim()}</li>`;
                    }
                    // Otherwise, wrap it in <p> tags
                    return `<p>${line.trim()}</p>`;
                })
                .join("");

            // Wrap <li> items in a <ul> tag
            content = content.replace(/(<li>.*?<\/li>)+/g, (match) => {
                return `<ul>${match}</ul>`;
            });

            return content;
        },
        formatLinks(content) {
            const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g;
            const referenceRegex = /【[^】]*】/g;

            // Remove reference links or content inside 【 】 brackets
            content = content.replace(referenceRegex, "");

            return content.replace(linkRegex, (match, text, url) => {
                // Replace http with https if found
                const secureUrl = url.startsWith("http://")
                    ? url.replace("http://", "https://")
                    : url;
                return secureUrl;
            });
        },
        reviewOlliebot(sentiment) {
            if (!this.ollieResponse) return;
            this.sentimentLoading = sentiment;
            axios
                .post(route("openAi.review", this.message.id), {
                    sentiment: sentiment,
                })
                .then(() => {
                    this.sentimentLoading = null;
                    this.ollieResponse = false;
                    this.$page.props.successMessage = "Thank you!";
                    this.$emit("showMessage");
                })
                .catch(() => {
                    this.sentimentLoading = null;
                    this.$emit(
                        "error",
                        "Something went wrong, please try again or contact support"
                    );
                });
        },
    },
    computed: {
        overCharacterLimit() {
            if (!this.characterLimit) return false;
            return (
                this.editor.storage.characterCount.characters() >
                this.characterLimit
            );
        },
        onScreenKeyboard() {
            return "ontouchstart" in document.documentElement;
        },
        formattingEnabled() {
            return this.editorType == "html";
        },
    },
    mounted() {
        const SubmitOnEnter = Extension.create({
            addKeyboardShortcuts: () => {
                return {
                    "Shift-Alt-Enter": ({ editor }) => this.submit(),
                };
            },
        });
        // Conditionally include extensions based on formattingEnabled
        const formattingExtensions = this.formattingEnabled
            ? [
                  Bold.extend({
                      renderHTML({ HTMLAttributes }) {
                          return ["b", HTMLAttributes, 0];
                      },
                  }),
                  Underline,
                  Italic.extend({
                      renderHTML({ HTMLAttributes }) {
                          return ["i", HTMLAttributes, 0];
                      },
                  }),
                  //Link,
                  Youtube.configure({
                      width: "100%",
                      height: 300,
                      inline: false,
                  }),
              ]
            : [];

        this.editor = new Editor({
            parseOptions: {
                preserveWhitespace: this.channel == "sms" ? false : "full",
            },
            content: this.value,
            extensions: [
                Document,
                Paragraph,
                History,
                Text,
                Placeholder.configure({
                    placeholder:
                        this.message?.id && this.channel == "email"
                            ? "Your reply..."
                            : "New message...",
                }),
                this.formattingEnabled
                    ? BulletList.configure({
                          keepMarks: false,
                      })
                    : "",
                ListItem,
                ...formattingExtensions,
                CharacterCount.configure({
                    //limit: this.characterLimit,
                    textCounter: () =>
                        this.editor.getText({ blockSeparator: "\n" }).length,
                }),
                Link.configure({
                    defaultProtocol: "https",
                }),
                SubmitOnEnter,
            ],
            autofocus: this.autofocus,
            editable: !this.disabled,
            editorProps: {
                attributes: {
                    class: "pa-2 focus:outline-none editor-content",
                },
                clipboardTextParser: this.clipboardTextParser,
            },
            onUpdate: () => {
                this.$emit("input", this.editor.getHTML());
            },
        });

        /*if (this.overCharacterLimit) {
            this.$emit("contentTrimmed");
        }*/
    },
    beforeDestroy() {
        this.editor.destroy();
    },
    watch: {
        processing(val) {
            this.editor.options.editable = !val;
        },
    },
};
</script>

<style scoped>
::v-deep .editor-content p.is-editor-empty:first-child::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
}

::v-deep .editor-content div.is-editor-empty:first-child::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
}

/*https://github.com/ueberdosis/tiptap/issues/4571*/

::v-deep .editor-content {
    max-height: 50vh;
    max-height: 50svh;
    overflow-y: auto;

    @media screen and (max-width: 960px) {
        max-height: 200px;
        overflow-y: auto;
    }
}

.tip-tap-submit {
    transform: translate(0, -4px);
}

.custom-animate.animate__animated.animate__fadeIn {
    --animate-duration: 0.3s;
}
</style>
